const Gallery = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <section className="bg-gradient-to-r from-primary to-primary-600 text-white py-20 text-center">
        <div className="container">
          <h1 className="text-5xl font-bold mb-4">Gallery</h1>
          <p className="text-xl max-w-2xl mx-auto">Moments from our school community</p>
        </div>
      </section>
      <section className="py-24">
        <div className="container text-center">
          <i className="fas fa-images text-8xl text-slate-300 mb-8"></i>
          <h2 className="text-3xl font-bold text-slate-800 mb-4">Coming Soon</h2>
          <p className="text-slate-500 text-xl">Our gallery is being curated. Check back soon for photos and videos.</p>
        </div>
      </section>
    </div>
  );
};

export default Gallery;
